import { StPopover, StPopoverTrigger } from "@storytell/ui/popover";
import type { Component } from "solid-js";
import { Dynamic } from "solid-js/web";
import { usePromptBarContext } from "../PromptBarContext";
import { useModelSelectorLogic } from "../hooks/useModelSelectorLogic";
import { ModelSelectorSection } from "./ModelSelectorSection";
import { PromptBarButton } from "./PromptBarButton";

/**
 * Compact preferences display showing model vendor and improve state
 * Clean, spaced layout positioned on the right side of prompt bar
 * Clickable to open settings menu
 */
export const CompactPreferences: Component = () => {
  const context = usePromptBarContext();
  const { currentVendor, currentModelName } = useModelSelectorLogic();
  const { knowledgeSources, credits } = context;
  return (
    <StPopover
      noArrow
      open={knowledgeSources.showTooltip()}
      onOpenChange={(open) => {
        if (open && credits.showTooltip()) {
          credits.setShowTooltip(false);
        }
        knowledgeSources.setShowTooltip(open);
      }}
      gutter={10}
      placement="bottom-end"
      flip
      contentProps={{ class: "w-80 bg-panel border border-primary-border rounded-xl shadow-xl" }}
      content={
        <div class="p-4 space-y-4">
          <ModelSelectorSection />
        </div>
      }
    >
      <StPopoverTrigger
        as={PromptBarButton}
        type="button"
        icon={() => <Dynamic component={currentVendor().icon} size={14} class={currentVendor().color} />}
        class="flex items-center gap-1.5 cursor-pointer hover:opacity-90 transition-opacity text-xs px-2"
        aria-label="Open settings"
      >
        {currentModelName()}
      </StPopoverTrigger>
    </StPopover>
  );
};
